import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const KustomerFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [accessToken, setAccessToken] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      integrationID={integrationID}
      inputFieldData={accessToken}
      setInputFieldData={setAccessToken}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        kustomer: {
          accessToken: accessToken,
        },
      }}
      updateAuthData={{
        kustomer: {
          accessToken: accessToken,
        },
      }}
      textFieldProps={{
        label: 'Access Token',
        placeholder: 'Enter Access Token',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
